import { GatesApi, GateResponseDto } from '@planning/app/api'
import { createApiClient } from '@planning/app/http-client'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetGatesQuery implements IQueryMessage {
  static type = 'GetGatesQuery'
  type = GetGatesQuery.type

  getKey = () => {
    return JSON.stringify(this)
  }
}

const httpClient = createApiClient(GatesApi)

// Fetches active AND inactive gates so names stay resolvable for gates that were
// deactivated after being stamped on a truck visit. Pickers filter on `active`.
export const getGatesQueryHandler: IQueryHandler<
  GetGatesQuery,
  IEvent<GateResponseDto[]>
> = async _ => {
  const { data } = await httpClient.get(true, true)

  return new Event(GetGatesQuery.type, data)
}
